import { SVGProps } from "react";

interface CopyIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

export default function CopyIcon({
  size = 16,
  className = "",
  ...props
}: CopyIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M4.33333 4.33333V11C4.33333 11.442 4.50893 11.866 4.82149 12.1785C5.13405 12.4911 5.55797 12.6667 6 12.6667H11M4.33333 4.33333V2.66667C4.33333 2.22464 4.50893 1.80072 4.82149 1.48816C5.13405 1.17559 5.55797 1 6 1H9.82167C10.0427 1.00005 10.2546 1.08788 10.4108 1.24417L14.0892 4.9225C14.2455 5.07874 14.3333 5.29067 14.3333 5.51167V11C14.3333 11.442 14.1577 11.866 13.8452 12.1785C13.5326 12.4911 13.1087 12.6667 12.6667 12.6667H11M4.33333 4.33333H2.66667C2.22464 4.33333 1.80072 4.50893 1.48816 4.82149C1.17559 5.13405 1 5.55797 1 6V14.3333C1 14.7754 1.17559 15.1993 1.48816 15.5118C1.80072 15.8244 2.22464 16 2.66667 16H9.33333C9.77536 16 10.1993 15.8244 10.5118 15.5118C10.8244 15.1993 11 14.7754 11 14.3333V12.6667"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
